export function objectToQueryString(object): string {
  if (!Object.keys(object).length) {
    return '';
  }
  let result = '?';
  Object.keys(object).forEach((key, index) => {
    result += `${key}=${object[key]}`;
    if (index !== Object.keys(object).length - 1) {
      result += '&';
    }
  });
  return result;
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/functions/commom.functions.ts